import { useState } from 'react';
import { Link } from 'react-router';
import { useUsers } from '../api/users';

export function UsersList() {
  const [includeDisabled, setIncludeDisabled] = useState(false);
  const usersQuery = useUsers({ includeDisabled });

  return (
    <div className="page">
      <div className="page-head">
        <h1>Users</h1>
        <div className="page-actions">
          <label className="micro" style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={includeDisabled}
              onChange={(e) => setIncludeDisabled(e.target.checked)}
            />
            Show disabled
          </label>
          <Link to="/users/new" className="btn btn-primary">
            New user
          </Link>
        </div>
      </div>

      {usersQuery.isPending && <div className="loading">Loading…</div>}
      {usersQuery.isError && <div className="error">Could not load users.</div>}
      {usersQuery.data && usersQuery.data.length === 0 && (
        <div className="empty">No users to show.</div>
      )}
      {usersQuery.data && usersQuery.data.length > 0 && (
        <div className="card">
          <table className="tbl">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th aria-label="Edit" />
              </tr>
            </thead>
            <tbody>
              {usersQuery.data.map((u) => (
                <tr key={u.id}>
                  <td>{u.displayName}</td>
                  <td>{u.email}</td>
                  <td>
                    <span className={u.role === 'owner' ? 'pill pill-merch' : 'pill'}>
                      {u.role}
                    </span>
                  </td>
                  <td>
                    {u.disabledAt ? (
                      <span className="pill pill-ended">disabled</span>
                    ) : (
                      <span className="pill pill-paid">active</span>
                    )}
                  </td>
                  <td>
                    <Link to={`/users/${u.id}/edit`} className="btn btn-ghost btn-sm">
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
